import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { css } from "styled-components";

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
    `,
    weight: 700,
};

productCountStyles.wrapper = {
    css: css`
        margin-left: 15px;
        margin-bottom: 15px;
    `,
};
